import { initializeApp, FirebaseApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, Messaging } from 'firebase/messaging';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

let app: FirebaseApp | null = null;
let messaging: Messaging | null = null;

export const initializeFirebase = (): FirebaseApp | null => {
    if (!app) {
        try {
            app = initializeApp(firebaseConfig);
        } catch (error) {
            console.error('Firebase initialization error:', error);
            return null;
        }
    }
    return app;
};

export const getFirebaseMessaging = (): Messaging | null => {
    if (!messaging && app) {
        try {
            messaging = getMessaging(app);
        } catch (error) {
            console.error('Firebase messaging not supported:', error);
            return null;
        }
    }
    return messaging;
};

export const requestNotificationPermission = async (): Promise<string | null> => {
    try {
        // Check if notifications are supported
        if (!('Notification' in window)) {
            console.warn('This browser does not support notifications');
            return null;
        }

        const permission = await Notification.requestPermission();
        if (permission !== 'granted') {
            console.warn('Notification permission denied');
            return null;
        }

        const fcmMessaging = getFirebaseMessaging();
        if (!fcmMessaging) return null;
        let token = "";
        try {
            token = await getToken(fcmMessaging, {
                vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
            });
        } catch (error) {
            console.error('Error getting FCM token:', error);
        }

        return token;
    } catch (error) {
        console.error('Error getting FCM token:', error);
        return null;
    }
};

export const onForegroundMessage = (callback: (payload: any) => void): (() => void) => {
    const fcmMessaging = getFirebaseMessaging();
    if (fcmMessaging) {
        return onMessage(fcmMessaging, callback);
    }
    return () => { };
};
